module.exports = __webpack_public_path__ + "static/media/orange_animal_insects_6.155a46ee.webp";